import { InjectionToken } from '@angular/core';
import { UniversalFilesystemService } from '../../vas/services/universal-filesystem/universal-filesystem.service';

export const CORE_FILESYSTEM_TOKEN = new InjectionToken<UniversalFilesystemService>('core-universal-filesystem-token');



// WEBPACK FOOTER //
// ./src/app/injection-tokens/universal-file-system.token.ts